import React, { Component } from 'react'
import * as actions from "../../posts/actions";

import TaggedGuests from "./tagged-guests";
import TagGuestsSearch from "./tag-guests-search";
import { connect } from 'react-redux';
import update from 'immutability-helper';

const TagGuestsStage = React.createClass({
  getInitialState() {
    return {
      tags: this.props.tags || []
    }
  },
  render() {
    const { tags, visible } = this.state;
    return (
      <div className="tag-guests-stage">
        <TaggedGuests
          tags={tags}
          handleRemoveTaggedGuest={this.handleRemoveTaggedGuest}
        />
        { this.props.tagSearchVisible &&
          <div>
            <TagGuestsSearch
              tags={tags}
              handleAddTaggedGuest={this.handleAddTaggedGuest}
              handleCloseSearch={this.props.handleCloseSearch}
            />
            { (this.props.showSubmitButton || this.props.showCancelButton) &&
              <div className="button-wrap">
                { this.props.showCancelButton &&
                  <button
                    type="button"
                    className="button-primary-inverse"
                    onClick={this.handleCancelClick}
                  >
                    Cancel
                  </button>
                }
                { this.props.showSubmitButton &&
                  <button
                    type="button"
                    className="button-primary"
                    onClick={this.handleSubmitClick}
                  >
                    Update
                  </button>
                }
              </div>
            }
          </div>
        }
      </div>
    );
  },
  handleAddTaggedGuest(user_id, name) {
    const user = {
      user_id,
      name
    }
    this.setState(
      update(this.state, {
        tags: {$push: [user]}
      })
    );
  },
  handleRemoveTaggedGuest(user_id) {
    let filtered = this.state.tags.filter(function(user) {
      return user.user_id !== user_id;
    });
    this.setState({
      tags: filtered
    });
  },
  handleCancelClick(e) {
    e.preventDefault();
    this.props.onCancel(e);
  },
  handleSubmitClick(e) {
    e.preventDefault();
    actions.updateTags(this.props.postId, this.state.tags);
    this.props.onTagsSubmitted(e);
  },
  resetStage() {
    this.setState(this.getInitialState());
  }
});

export default TagGuestsStage;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/tag-guests/components/tag-guests-stage.es6